import { render, staticRenderFns } from "./InviteJoinLose.vue?vue&type=template&id=5ded42b1&scoped=true"
import script from "./InviteJoinLose.vue?vue&type=script&lang=js"
export * from "./InviteJoinLose.vue?vue&type=script&lang=js"
import style0 from "./InviteJoinLose.vue?vue&type=style&index=0&id=5ded42b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded42b1",
  null
  
)

export default component.exports